import { TwoFASuccess } from "@src/components/modules/auth/2fa-success";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const AuthTwoFactorSuccess = () => {
  return (
    <>
      <NoIndexHead />
      <TwoFASuccess />
    </>
  );
};
export const Route = createFileRoute("/auth/two-factor/success")({
  component: AuthTwoFactorSuccess,
});
